"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bifurcateBy = exports.bifurcateWhen = void 0;
function bifurcateWhen(delim, ts) {
    var doit = function (ts) {
        var reducer = function (memo, v) {
            if (memo.found) {
                return __assign(__assign({}, memo), { tail: __spreadArray(__spreadArray([], memo.tail), [v]) });
            }
            else if (delim(v)) {
                return __assign(__assign({}, memo), { found: true });
            }
            else {
                return __assign(__assign({}, memo), { head: __spreadArray(__spreadArray([], memo.head), [v]) });
            }
        };
        var _a = ts.reduce(reducer, {
            found: false,
            head: [],
            tail: [],
        }), head = _a.head, tail = _a.tail;
        return [head, tail];
    };
    return typeof ts === 'undefined' ? doit : doit(ts);
}
exports.bifurcateWhen = bifurcateWhen;
function bifurcateBy(fn, ts) {
    var doit = function (ts) {
        var reducer = function (memo, t) {
            return fn(t) ? __assign(__assign({}, memo), { head: __spreadArray(__spreadArray([], memo.head), [t]) }) : __assign(__assign({}, memo), { tail: __spreadArray(__spreadArray([], memo.tail), [t]) });
        };
        var _a = ts.reduce(reducer, { head: [], tail: [] }), head = _a.head, tail = _a.tail;
        return [head, tail];
    };
    return typeof ts === 'undefined' ? doit : doit(ts);
}
exports.bifurcateBy = bifurcateBy;
